import UserPassengerListResponse, {
  UserPassengerListResponseItem,
  UserPassengerListResponseItemCargoCompany,
  UserPassengerListResponseItemDispatch,
  UserPassengerListResponseItemAddress,
} from "../../../../api/raily/user/passenger/list/user-passenger-list.response";
import UserPassengerList, {
  UserPassengerListItem,
  UserPassengerListItemAddress,
  UserPassengerListItemCargoCompany,
  UserPassengerListItemDispatch,
} from "./user-passenger-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserPassengerListResponseItem,
): UserPassengerListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserPassengerListResponseItem,
): UserPassengerListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createCargoCompany = (
  cargoCompany: UserPassengerListResponseItemCargoCompany,
): UserPassengerListItemCargoCompany => {
  return {
    name: cargoCompany.companyName,
  };
};

const createDispatch = (
  dispatch: UserPassengerListResponseItemDispatch,
): UserPassengerListItemDispatch => {
  return {
    displayName: dispatch.displayName,
    cargoCompany: createCargoCompany(dispatch.cargoCompany),
  };
};

const createAddress = (
  passenger: UserPassengerListResponseItemAddress,
): UserPassengerListItemAddress => {
  return {
    displayName: passenger.displayName,
  };
};

const createDataItem = (
  responseDataItem: UserPassengerListResponseItem,
): UserPassengerListItem => {
  return {
    uuid: responseDataItem.id,
    removalDate: responseDataItem.removedAt,
    addresses: responseDataItem.passenger.addresses.map((address) =>
      createAddress(address),
    ),
    dispatches: responseDataItem.passenger.dispatches.map((dispatch) =>
      createDispatch(dispatch),
    ),
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    email: responseDataItem.email,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    username: responseDataItem.username,
    phoneNumber: createPhoneNumber(responseDataItem),
  };
};

const createData = (
  responseData: UserPassengerListResponseItem[],
): UserPassengerListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: UserPassengerListResponse): UserPassengerList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userPassengerListFactory = {
  create,
};

export default userPassengerListFactory;
